module.exports = __webpack_public_path__ + "img/image2.765f6d37.png";